module.exports = __webpack_public_path__ + "img/icon-alternative-audio.cc40ba50.svg";